import request from 'superagent';
import { browserHistory } from 'react-router';
import { addError, addStatus, authCarrotQuestEvent } from './utils';
import { startLoad, finishLoad } from './loader';
import { userApi } from '@api/user';
import { I18n } from 'react-redux-i18n';

export function receiveAuth(user) {
  return {
    type: 'RECEIVE_AUTH',
    user,
  };
}

function updateAuth(user) {
  return {
    type: 'UPDATE_AUTH',
    user,
  };
}

function receiveReset(result) {
  return {
    type: 'RECEIVE_RESET',
    result,
  };
}

function receiveConfirm(result) {
  return {
    type: 'RECEIVE_CONFIRM',
    result,
  };
}

function receiveCheckPassword(result) {
  return {
    type: 'RECEIVE_CHECK_PASSWORD',
    result,
  };
}

function receiveLogout(result) {
  return {
    type: 'RECEIVE_LOGOUT',
    result,
  };
}

export function receiveTether(tether) {
  return {
    type: 'RECEIVE_TETHER',
    tether,
  };
}

function receiveAvatar(avatar) {
  return {
    type: 'RECEIVE_AVATAR',
    avatar,
  };
}

function receiveChildren(children) {
  return {
    type: 'RECEIVE_CHILDREN',
    children,
  };
}

export function auth(email, password, mailSend) {
  return dispatch => {
    dispatch(startLoad('auth', 'Авторизация'));
    request
      .post('/user/login')
      .send({ username: email, password })
      .set('Accept', 'application/json')
      .end((err, res) => {
        dispatch(finishLoad('auth'));
        if (err) {
          dispatch(addError((res && res.body) || err));
          dispatch(receiveAuth(false));
        } else {
          dispatch(receiveAuth(res.body));
          authCarrotQuestEvent();
          // browserHistory.push('/i');
          if (res.body && !res.body.confirmed) {
            if (!mailSend) {
              dispatch(addStatus(I18n.t('auth.confirm.pleaseConfirm')));
            } else {
              dispatch(addStatus(I18n.t('auth.confirm.checkMail')));
            }
          }
        }
      });
  };
}

export function fetchAuth() {
  return dispatch => {
    request
      .post('/user/loggedin')
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          dispatch(updateAuth(false));
        } else {
          dispatch(updateAuth(res.body));
        }
      });
  };
}

export function logout() {
  return dispatch => {
    dispatch(startLoad('logout', 'Выход'));
    request.post('/user/logout').end((err, res) => {
      dispatch(finishLoad('logout'));
      if (err) {
        dispatch(addError(res.body));
      } else {
        dispatch(receiveLogout());
        if (res.body && res.body.rtsLogoutUrl) {
          window.location.href = res.body.rtsLogoutUrl;
          return;
        }
        //browserHistory.push('/i/auth');
      }
    });
  };
}

export function registerNew(options) {
  return async dispatch => {
    dispatch(startLoad('register', 'Регистрация', true));
    try {
      const { email, name, password } = options;
      const user = await userApi.register(options);
      if (user) {
        dispatch(auth(email || name, password, true));
      }
    } catch (error) {
      dispatch(addError(error.response.body.error));
    }
    dispatch(finishLoad('register'));
  };
}

export function register(
  email,
  phone,
  realname,
  password,
  school,
  sendEmails,
  language,
  invite
) {
  return dispatch => {
    dispatch(startLoad('register', 'Регистрация', true));
    request
      .post('/user/register')
      .send({
        email,
        phone,
        realname,
        nickname: '',
        password,
        school,
        sendEmails,
        language,
        invite,
      })
      .end((err, res) => {
        if (err) {
          dispatch(addError(err));
        } else {
          if (!school) dispatch(auth(email, password, true));
          else
            dispatch(
              addStatus(
                `Аккаунт ${email} успешно зарегистрирован, подписка будет активирована после первого входа`
              )
            );
        }
        dispatch(finishLoad('register'));
      });
  };
}

export function registerWithToken(token, language) {
  return dispatch => {
    dispatch(startLoad('register', 'Регистрация'));
    request
      .post(`/user/register/${token}`)
      .send({ language })
      .end((err, res) => {
        dispatch(finishLoad('register'));
        if (err) {
          dispatch(addError(err));
          dispatch(receiveAuth(false));
        } else {
          dispatch(receiveAuth(res.body));
          //browserHistory.push("/i");
        }
      });
  };
}

export function setPassword(password) {
  return dispatch => {
    dispatch(startLoad('setPassword', 'Устанавливаем пароль'));
    request
      .post('/user/setPassword')
      .send({ password })
      .end((err, res) => {
        dispatch(finishLoad('setPassword'));
        if (err) {
          dispatch(addError(err));
        } else {
          dispatch(checkPassword());
        }
      });
  };
}

export function fetchSsoInitialPassword() {
  return request.get('/user/sso-initial-password').then(res => {
    const body = res.body || {};
    if (!body.password) {
      return null;
    }
    return body;
  });
}

export function checkPassword() {
  return dispatch => {
    request.post('/user/checkPassword').end((err, res) => {
      if (err) {
        dispatch(addError(err));
      } else {
        dispatch(receiveCheckPassword(res.body));
      }
    });
  };
}

export function reset(email) {
  return dispatch => {
    dispatch(startLoad('reset', 'Сброс пароля'));
    request
      .post('/user/reset')
      .send({ username: email })
      .set('Accept', 'application/json')
      .end((err, res) => {
        dispatch(finishLoad('reset'));
        if (err) {
          dispatch(addError(res.body));
          dispatch(receiveReset(false));
        } else {
          dispatch(receiveReset(true));
        }
      });
  };
}

export function sendConfirm(email) {
  return dispatch => {
    dispatch(startLoad('confirm', 'Подтверждение почты'));
    request
      .post('/user/confirm')
      .send({ email: email })
      .set('Accept', 'application/json')
      .end((err, res) => {
        dispatch(finishLoad('confirm'));
        if (err) {
          dispatch(addError(res.body));
          dispatch(receiveReset(false));
        } else {
          dispatch(addStatus(I18n.t('auth.confirm.checkMail')));
          dispatch(receiveReset(true));
        }
      });
  };
}

export function applyConfirm(token) {
  return dispatch => {
    dispatch(startLoad('confirm', 'Подтверждение почты'));
    request.post(`/user/confirm/${token}`).end((err, res) => {
      dispatch(finishLoad('confirm'));
      if (err) {
        dispatch(receiveConfirm(false));
      } else {
        dispatch(receiveConfirm(true));
      }
    });
  };
}

export function changePassword(password, token) {
  return dispatch => {
    dispatch(startLoad('changePassword', 'Изменение пароля'));
    request
      .post(`/user/reset/${token}`)
      .send({ password })
      .set('Accept', 'application/json')
      .end((err, res) => {
        dispatch(finishLoad('changePassword'));
        if (err) {
          dispatch(addError(res.body));
        } else {
          dispatch(receiveLogout(true));

          //TODO: check this, wtf
          browserHistory.push('/i/auth');
        }
      });
  };
}

export function editPassword(password, newPassword) {
  return dispatch => {
    dispatch(startLoad('editPassword', 'Изменение пароля'));
    request
      .post('/user/changePassword')
      .send({ password, newPassword })
      .end((err, res) => {
        dispatch(finishLoad('editPassword'));
        if (err) {
          dispatch(addError(res.body));
          dispatch(receiveReset(false));
        } else {
          dispatch(receiveReset(true));
        }
      });
  };
}

export function changeName(name) {
  return dispatch => {
    dispatch(startLoad('changeName', 'Изменение ника'));
    request
      .post('/user/changeName')
      .send({ nickname: name })
      .end((err, res) => {
        dispatch(finishLoad('changeName'));
        if (err) {
          dispatch(addError(res.body));
          dispatch(receiveTether({ result: false }));
        } else {
          dispatch(receiveTether(res.body));
        }
      });
  };
}

export function updateProfile(data) {
  return dispatch => {
    dispatch(startLoad('updateProfile', 'Изменение данных профиля'));
    request
      .post('/user/updateProfile')
      .send({ data })
      .end((err, res) => {
        dispatch(finishLoad('updateProfile'));
        if (err) {
          dispatch(addError(res.body));
          dispatch(receiveTether({ result: false }));
        } else {
          dispatch(fetchAuth());
          dispatch(receiveTether(res.body));
        }
      });
  };
}

function emailCheck(result) {
  return {
    type: 'EMAIL_CHECK',
    result,
  };
}

export function checkEmail(email, callback) {
  return dispatch => {
    request
      .post('/user/emailtaken')
      .send({ email })
      .end((err, res) => {
        if (err) {
          dispatch(addError(res.body));
          dispatch(emailCheck(false));
        } else {
          dispatch(emailCheck(res.body));
        }
        callback();
      });
  };
}

function nicknameCheck(result) {
  return {
    type: 'NICKNAME_CHECK',
    result,
  };
}

export function checkNickname(nickname) {
  return dispatch => {
    request
      .post('/user/nicktaken')
      .send({ nickname })
      .end((err, res) => {
        if (err) {
          dispatch(addError(res.body));
          dispatch(nicknameCheck(false));
        } else {
          dispatch(nicknameCheck(res.body));
        }
      });
  };
}

export function loadChildren() {
  return dispatch => {
    dispatch(startLoad('loadChildren', 'Обновление списка детей'));
    request
      .get('/user/children')
      .send()
      .end((err, res) => {
        dispatch(finishLoad('loadChildren'));
        if (err) {
          dispatch(addError(res.body));
        } else {
          dispatch(receiveChildren(res.body));
        }
      });
  };
}

export function changeAvatar(path) {
  return dispatch => {
    dispatch(startLoad('changeAvatar', 'Изменение аватара'));
    request
      .post('/user/changeAvatar')
      .send({ avatar: path })
      .end((err, res) => {
        dispatch(finishLoad('changeAvatar'));
        if (err) {
          dispatch(addError(res.body));
        } else {
          dispatch(receiveAvatar(res.body));
        }
      });
  };
}

export function changeSendEmails(sendEmails) {
  return dispatch => {
    request
      .post('/user/sendEmails')
      .send({ sendEmails })
      .end((err, res) => {
        if (err) {
          dispatch(addError(res.body));
        } else {
          if (sendEmails) {
            dispatch(addStatus('Вы успешно подписались на рассылку'));
          } else {
            dispatch(addStatus('Вы отписаны от рассылки'));
          }
        }
      });
  };
}

export function changeSendLessonSmsNotifications(sendLessonSmsNotifications) {
  return dispatch => {
    request
      .post('/user/sendLessonSmsNotifications')
      .send({ sendLessonSmsNotifications })
      .end((err, res) => {
        if (err) {
          dispatch(addError(res.body));
        } else {
          if (sendLessonSmsNotifications) {
            dispatch(addStatus('Вы успешно подписались на уведомления'));
          } else {
            dispatch(addStatus('Вы отписаны от уведомлений'));
          }
        }
      });
  };
}
